import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContactUsModel } from './contactus.model';
import { environment } from 'src/environments/environment';

@Injectable()

export class ContactUsService {

    constructor(private readonly _http: HttpClient) {
    }


    addContactUs(contact: ContactUsModel) : Observable<any> {
        return this._http.post<any>(`${environment.baseApiUrl}api/ContactUs/add`, contact);
        
    }

}